import React from 'react'
import { Locale, Translation } from 'locale'
import { TextButton, TextButtonType } from '../buttons'
import { ModalWindow, ModalContent, ModalFooter } from './ModalWindow'

export interface DialogWindowProps {
  title: Translation
  titleArgs?: any
  closeLabel?: Translation
  confirmLabel: Translation
  confirmButtonEnabled: boolean
  onClose?: () => unknown
  onConfirm: () => unknown
  children?: React.ReactNode
}

export class DialogWindow extends React.Component<DialogWindowProps> {
  render() {
    const { children, title, titleArgs, onClose, onConfirm, closeLabel, confirmLabel, confirmButtonEnabled } = this.props
    return (
      <ModalWindow title={Locale.translate(title, titleArgs)}>
        <ModalContent>{children}</ModalContent>
        <ModalFooter>
          <TextButton dataTestId={'DialogWindow-TextButton-CloseLabel-ButtonCancel'} type={TextButtonType.Tertiary} onClick={onClose}>
            {Locale.translate(closeLabel || Translation.TC_BUTTON_CANCEL)}
          </TextButton>
          <TextButton
            dataTestId={'DialogWindow-TextButton-ConfirmLabel'}
            type={TextButtonType.Primary}
            disabled={!confirmButtonEnabled}
            onClick={onConfirm}>
            {Locale.translate(confirmLabel)}
          </TextButton>
        </ModalFooter>
      </ModalWindow>
    )
  }
}
